import CONFIG from './config';
import React, { Component } from 'react';
import Icon from './Icons';
import { Link } from 'react-router-dom';

export const categories = {
	"Development": {
		icon: "code",
		style: {
			padding: "0px",
			backgroundColor: "#4cad8a",
			color: "#fff"
		},
		className: "icon-xs"
	},
	"Red Teaming": {
		icon: "book-dead",
		style: {
			padding: "0px",
			backgroundColor: "#ad4c4c",
			color: "#fff"
		},
		className: "icon-xs"
	},
	"Projects": {
		icon: "project-diagram",
		style: {
			padding: "0px",
			backgroundColor: "#4c79ad",
			color: "#fff"
		},
		className: "icon-xs"
	},
	"Tricks": {
		icon: "lightbulb",
		style: {
			padding: "0px",
			backgroundColor: "#ad874c",
			color: "#fff"
		},
		className: "icon-xs"
	},

}

export class CategoryIcon extends Component {
	render() {
		const { category } = this.props;
		return (
			<Icon {...categories[category]} />
		)
	}
}

export class Categories extends Component {
	render() {
		const category_links = Object.keys(categories).map((k,c) => {
			return (
				<div className="group category-link">
					<Link to={`/search/category/${k}`}>
						<CategoryIcon category={k} />
						<div className='category-title'>
							{k}
						</div>
					</Link>
				</div>
			)
		})
		return (
			<div className="categories">
				{ category_links }
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./src/Category.js